// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetFallback_container__p4ZtU"};